define(['./_overArg'], function(overArg) {

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);

  return nativeKeys;
});
